<template>
    <div>
<!--        <page-header :title="$t('pages.gym.title')" icon-class="mdi mdi-dumbbell"/>-->

        <div class="row mb-3" v-if="!$store.getters.isExecutingRequest">
            <div class="col-md-9">
                <div class="vjs-responsive">
                    <video-player
                        :options="playerOptions"
                        class="vjs-custom-skin"
                        ref="videoPlayer"
                        @timeupdate="onPlayerTimeupdate($event)"
                        @ready="playerReadied"
                        @pause="updateViewProgress"
                    >
                    </video-player>
                </div>
            </div>
            <div class="col-md-3 stretch-card">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <h4 class="text-primary oswald">
                            <!-- {{ $t('pages.admin.viddeo.upload.goal_group_' + i) }} -->
                            {{ $t('pages.admin.video.upload.focuses_on') }}
                        </h4>
                        <hr>
                        <ul>
                            <li v-for="item in video.goals">
                                {{ item.label[$i18n.locale] }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <static-loading-indicator-icon/>

                        <div v-if="!$store.getters.isExecutingRequest">
                            <div class="row" v-if="video">
                                <div class="col-md-9">
                                    <h5 class="card-title">
                                        <span class="oswald">{{ videoTitle }}</span>
                                    </h5>

                                    <gym-video-level-badge :level="video.level" :label="video.localized_level"/>
                                    <gym-video-intensity-badge :intensity="video.intensity"/>
                                    <gym-video-duration-badge :duration="video.duration"/>
                                </div>

                                <div class="col-md-3 text-right">
                                    <i class="mdi mdi-36px" :class="[watchedEntirely ? 'mdi-check-decagram text-primary' : '']"></i>
                                    <i class="mdi mdi-36px cursor-pointer"
                                       :class="[
                                           isVideoFavored ? 'mdi-heart text-primary' : 'mdi-heart-outline text-muted',
                                           favButtonHovered ? 'text-primary' : ''
                                           ]"
                                       @mouseenter="favButtonHovered = true"
                                       @mouseleave="favButtonHovered = false"
                                       @click="toggleFavorVideo"></i>
                                </div>
                            </div>


                            <hr>

                            <p>
                                <strong>{{ $t('pages.gym.equipment_needed') }}</strong>
                            </p>
                            <p class="text-muted">
                                {{ equipment }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GymRepository from "../../repositories/Gym/GymRepository";
import PageHeader from "../Includes/PageHeader";
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

import StaticLoadingIndicatorIcon from "../Includes/StaticLoadingIndicatorIcon";
import GymVideoLevelBadge from "./Includes/Badges/GymVideoLevelBadge";
import GymVideoIntensityBadge from "./Includes/Badges/GymVideoIntensityBadge";
import GymVideoDurationBadge from "./Includes/Badges/GymVideoDurationBadge";
export default {
    name: "GymVideo",
    components: {
        GymVideoDurationBadge,
        GymVideoIntensityBadge, GymVideoLevelBadge, StaticLoadingIndicatorIcon, PageHeader, videoPlayer},
    data: () => ({
       video: {
           title: [],
           equipment: [],
           localized_level: '',
           intensity: 0,
           duration: 0,
           level: 0,
           published_at: null
       },
       currentTimestamp: 0,
       playerOptions: {
           playbackRates: [0.25, 0.5, 1.0, 2.0, 4.0],
           sources: [],
           muted: false,
           autoplay: true,
           fluid: true,
       },
        favButtonHovered: false,
       lastViewProgressSent: 0
    }),
    computed: {
        // goalsByGroup() {
        //     return _.groupBy(this.video.goals, goal => goal.group);
        // },
        videoTitle() {
            if(this.video.title[this.$i18n.locale] === null) {
                if(this.video.title["en"] !== null)
                    return this.video.title["en"]
                else
                    return this.video.title.find(t => t !== null) || "???";
            }

            return this.video.title[this.$i18n.locale];
        },
        equipment() {
            if(this.video.equipment[this.$i18n.locale] === null) {
                if(this.video.equipment["en"] !== null)
                    return this.video.equipment["en"]
                else
                    return this.video.equipment.find(t => t !== null) || "???";
            }

            return this.video.equipment[this.$i18n.locale];
        },
        player() {
            return this.$refs.videoPlayer.player;
        },
        startedWatching() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            return this.video.user.playtime !== 0;
        },
        percentageWatched() {
            if(!this.startedWatching)
                return 0;

            let videoLength = this.video.length;
            let secondsWatched = this.video.user.playtime;

            return (secondsWatched / videoLength) * 100;
        },
        watchedEntirely() {
            if(!this.startedWatching)
                return false;

            return this.video.user.completed;
        },
        isVideoFavored() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            return this.video.user.favored;
        }
    },
    watch: {
      currentTimestamp: function(val) {
          let diff = (val > this.lastViewProgressSent) ? val - this.lastViewProgressSent : this.lastViewProgressSent - val;

          if(diff >= 5)
              this.updateViewProgress();
      }
    },
    methods: {
        toggleFavorVideo() {
            if(typeof this.video === 'undefined' || typeof this.video.user === 'undefined')
                return false;

            let oldState = this.video.user.favored;
            this.video.user.favored = !this.video.user.favored;
            GymRepository
                .toggleFavorVideo(this.video.id)
                .catch((err) => this.video.user.favored = oldState);
        },
        onPlayerTimeupdate(x) {
            this.currentTimestamp = Math.floor(this.player.currentTime());
        },
        playerReadied() {
            this.player.controlBar.addChild('QualitySelector');

            if(this.startedWatching) {
                let timestamp = this.video.user.playtime;

                // if the video has been nearly watched before, start from 0
                if(this.percentageWatched >= 99)
                    timestamp = 0;

                this.currentTimestamp = timestamp;
                this.player.currentTime(timestamp);
            }
        },
        updateViewProgress() {
            this.lastViewProgressSent = this.currentTimestamp;
            GymRepository
                .updateViewProgress(this.video.id, this.currentTimestamp)
                .then((res) => {
                    this.video.user.completed = res.data.completed;
                });
        }
    },
    beforeDestroy() {
        if(!this.$store.getters.isExecutingRequest) {
            if(typeof this.$route.params.video !== 'undefined')
                this.updateViewProgress();
        }
    },
    mounted() {
        GymRepository
            .getVideo(this.$route.params.video)
            .then((res) => {
                this.video = res.data;
                this.playerOptions.sources[0] = {
                    type: 'video/mp4',
                    src: this.video.kiss_video.media_url
                };

                let sources = this.video.kiss_video.streams;

                if(sources.length > 1) {
                    sources = sources.filter(stream => stream.resolution !== 'Default');
                }

                sources = sources
                    .sort((a, b) => a.resolution - b.resolution)
                    .reverse()
                    .map(stream => {
                    return {
                        src: stream.url,
                        type: 'video/mp4',
                        label: stream.resolution === 'Default' ? stream.resolution : stream.resolution + 'p',
                    };
                });

                this.playerOptions.sources = sources;
                this.playerOptions.poster = this.video.kiss_video.thumbnail_url;
            });
    }
}
</script>

<style scoped>

</style>
